<script>
    import WPNGeneralTable from "./WPNGeneralTable.svelte";
    import { workMaterialsData } from "../../scripts/wpn2DB.js";

    export let item;
    let materialsData;

    $: materialsData = workMaterialsData(item.materials ?? []);

</script>

{#if workMaterialsData.length > 0}
    <WPNGeneralTable
        tableData={materialsData}
        on:item-edit
        on:item-remove
        on:
    />
{/if}
